window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.baseURL = window.__api_base_url__;
window.axios.defaults.withCredentials = true;

window['__language_path__'] = '';
window['__default_path__'] = '/';

if (window.__host__ && window.__host__['is_default_language'] === false) {
    window['__language_path__'] = `/${window.__host__['language_code']}`;
    window['__default_path__'] = `/${window.__host__['language_code']}`;
}

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error(
        'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token'
    );
}

window.getAllUrlParams = function (url) {
    // get query string from url (optional) or window
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);

    // we'll store the parameters here
    var obj = {};

    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];

        // split our query string into its component parts
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            // separate the keys and the values
            var a = arr[i].split('=');

            // set parameter name and value (use 'true' if empty)
            var paramName = a[0];
            var paramValue = typeof a[1] === 'undefined' ? true : a[1];

            // if the paramName ends with square brackets, e.g. colors[] or colors[2]
            if (paramName.match(/\[(\d+)?\]$/)) {
                // create key if it doesn't exist
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) {
                    obj[key] = [];
                }

                // if it's an indexed array e.g. colors[2]
                if (paramName.match(/\[\d+\]$/)) {
                    // get the index value and add the entry at the appropriate position
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    // otherwise add the value to the end of the array
                    obj[key].push(paramValue);
                }
            } else {
                // we're dealing with a string
                if (!obj[paramName]) {
                    // if it doesn't exist, create property
                    obj[paramName] = paramValue;
                } else if (
                    obj[paramName] &&
                    typeof obj[paramName] === 'string'
                ) {
                    // if property does exist and it's a string, convert it to an array
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    // otherwise add the property
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
};

/*
 Global Http Request interceptor
*/
window.axios.interceptors.request.use(
    function (request) {
        // extract query values from request url
        let params = window.getAllUrlParams(
            window.__api_base_url__ + request.url
        );
        request.url = request.url.split('?')[0];
        request.params = params;
        request.params['adb'] = false;

        // append user age and gender property
        if (window.__user__) {
            if (
                window.__user__.age !== null &&
                window.__user__.age !== undefined
            ) {
                request.params['uA'] = window.__user__.age;
            }

            if (
                window.__user__.gender !== null &&
                window.__user__.gender !== undefined
            ) {
                request.params['uG'] = window.__user__.gender;
            }
        }
        if (window.__token__) {
            request.params['t'] = window.__token__;
        }

        if (window.__clId__) {
            request.params['clId'] = window.__clId__;
        }

        if (window.__host__) {
            if (window.__raw_keyword__) {
                request.params['keyword'] = window.__raw_keyword__;
            }

            if (window.__kwid__) {
                request.params['kwid'] = window.__kwid__;
            }
        }

        if (window.__user_timezone__) {
            request.params['uT'] = window.__user_timezone__;
        }

        if (window.__traffic_source__) {
            request.params['traffic_source'] = window.__traffic_source__;
        }

        // partner level content ab_test param
        if (
            window.__partner_row_ab_test_param__ &&
            window.__partner_row_ab_test_value__
        ) {
            request.params[window.__partner_row_ab_test_param__] =
                window.__partner_row_ab_test_value__;
        }

        // category level content ab_test param
        if (
            window.__category_ab_test_param__ &&
            window.__category_ab_test_value__
        ) {
            request.params[window.__category_ab_test_param__] =
                window.__category_ab_test_value__;
        }

        if (window.__template__) {
            request.params['template'] = window.__template__;
        }

        if (window['__host__']) {
            request.params['vertical_id'] = window['__host__']['project_id'];
        }

        if (window['canRunAds'] === false) {
            request.params['adb'] = true;
        }

        if (window.localStorage !== undefined) {
            if (localStorage.quiz_answers) {
                request.params['quiz_answers'] = localStorage.quiz_answers;
            }
        }

        if (window.__is_mobile__) {
            request.params['device_type'] = 'm';
        } else if (request.url.includes('ghost-writer')) {
            request.params['device_type'] = 'c';
        }

        if (
            window['__host__'] &&
            window['__host__']['sidebar_billboard_provider_id']
        ) {
            request.params['sidebar_billboard_provider_id'] =
                window['__host__']['sidebar_billboard_provider_id'];
        }

        return request;
    },
    function (error) {
        return Promise.reject(error);
    }
);
